import PreAnalyticalSetup from "../../laboratory/catalog/preAnalytical";
import AnalyticalSetup from "../../laboratory/catalog/analytical";
import PostAnalyticalSetup from "../../laboratory/catalog/postAnalytical";

/**
 * Offers > Consumables: the supplies each service uses, per phase, as tagged
 * by the laboratory. View only, the tagging drives the auto-consume upon
 * onboarding, so only the lab (MLS) changes it.
 */
export const PreAnalyticalConsumables = () => <PreAnalyticalSetup readOnly />;
export const AnalyticalConsumables = () => <AnalyticalSetup readOnly />;
export const PostAnalyticalConsumables = () => <PostAnalyticalSetup readOnly />;
